"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customFingerprintHook = void 0;
exports.customFingerprintHook = function (event, hint) {
    var _a;
    if (event && !event.fingerprint) {
        var fingerprint = (_a = hint === null || hint === void 0 ? void 0 : hint.originalException) === null || _a === void 0 ? void 0 : _a.customSentryFingerprint;
        event.fingerprint = fingerprint;
    }
    return event;
};
//# sourceMappingURL=eventHook.js.map